import '../../assets/index12.css';var x = Object.defineProperty, y = Object.defineProperties;
var z = Object.getOwnPropertyDescriptors;
var s = Object.getOwnPropertySymbols;
var n = Object.prototype.hasOwnProperty, d = Object.prototype.propertyIsEnumerable;
var r = (e, a, o) => a in e ? x(e, a, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[a] = o, t = (e, a) => {
  for (var o in a || (a = {}))
    n.call(a, o) && r(e, o, a[o]);
  if (s)
    for (var o of s(a))
      d.call(a, o) && r(e, o, a[o]);
  return e;
}, m = (e, a) => y(e, z(a));
var c = (e, a) => {
  var o = {};
  for (var l in e)
    n.call(e, l) && a.indexOf(l) < 0 && (o[l] = e[l]);
  if (e != null && s)
    for (var l of s(e))
      a.indexOf(l) < 0 && d.call(e, l) && (o[l] = e[l]);
  return o;
};
import { jsxs as P, jsx as p } from "react/jsx-runtime";
import { forwardRef as j } from "react";
import { c as k, d as w } from "../../factory-ueRxoNOV.js";
import { P as F } from "../../Paper-SFv53Ubl.js";
const R = "Tile-module__label___gzFo8", B = "Tile-module__badge___kmcI0", C = "Tile-module__root___OLkd7 Tile-module__sizes___rfRt- Tile-module__variants___pSpu2 Tile-module__orientations___U-slG Tile-module__badged___FbguZ", i = {
  label: R,
  badge: B,
  root: C
}, G = {
  size: "sm",
  variant: "primary",
  orientation: "vertical"
}, b = j((e, a) => {
  const _ = t(t({}, G), e), {
    badge: o,
    children: l,
    icon: u,
    orientation: T,
    size: g,
    variant: f,
    className: h,
    width: v
  } = _, N = c(_, [
    "badge",
    "children",
    "icon",
    "orientation",
    "size",
    "variant",
    "className",
    "width"
  ]);
  return /* @__PURE__ */ P(
    F,
    m(t({
      component: "button",
      className: k(i.root, h),
      style: { width: v },
      ref: a,
      mod: {
        size: g,
        orientation: T,
        variant: f,
        badged: !!o
      }
    }, N), {
      children: [
        u,
        /* @__PURE__ */ p("span", { className: i.label, children: l }),
        o && /* @__PURE__ */ p("div", { className: i.badge, children: o })
      ]
    })
  );
});
b.displayName = "Tile";
const Z = w(b);
export {
  Z as Tile
};
